export function cleanAndFixOrderNumber(orderNumber) {
  if (!orderNumber) return;
  // Convert to string before trimming
  const orderStr = String(orderNumber).trim();
  // console.log({orderStr: orderStr})
  if (isSkarAudioOrder(orderStr) && !orderStr?.startsWith('#')) {

    return `#${orderStr}`;
  }
  return orderStr;
}

export function isSkarAudioOrder(orderNumber) {
  if (!orderNumber) return;
  orderNumber = fixOrderNumberRemoveHash(orderNumber);
  return orderNumber?.length === 9 || orderNumber?.length === 10; // length without sha-256.mjs
}

export function fixOrderNumberRemoveHash(orderNumber) {
  if (!orderNumber) return;
  const inputValue = typeof orderNumber === 'number'
    ? String(orderNumber)
    : typeof orderNumber === 'string'
      ? orderNumber
      : null;
  if (inputValue === null) {
    console.warn('Invalid order number type:', typeof orderNumber);
    return;
  }
  const cleanedNumber = inputValue?.replace('#', '').trim();
  return cleanedNumber;
}
export function fixOrderNumberAddHash(orderNumber) {
  if (!orderNumber) return;
  orderNumber = orderNumber?.trim();
  console.log({fixOrderNumberAddHash_orderNumber: orderNumber})
  if (isSkarAudioOrder(orderNumber) && !orderNumber?.startsWith('#')) {
    return '#' + orderNumber;
  }
  return orderNumber;
}
